<template>
    <div>
        <modal ref="modal" :has-footer="false" :size="modalSize">
            <div class="d-block text-center" slot="title">Send Group Invites</div>
            <div class="animated animated-normal fadeIn" :key="key">
                <div class="form-group">
                    <label>Location</label>
                    <multiselect id="location_id"
                                 :options="locations"
                                 placeholder="Select a location"
                                 track-by="id"
                                 label="name"
                                 v-model="location_id"
                                 @select="locationSelected">
                    </multiselect>
                    <p class="invalid-feedback" v-if="form.errors.has('location_id')">
                        {{ form.errors.get('location_id') }}
                    </p>
                </div>
                <div class="form-group">
                    <label>Campaign</label>
                    <multiselect id="campaign_id"
                                 v-model="campaign_id"
                                 :options="campaigns"
                                 placeholder="Select a campaign"
                                 track-by="id"
                                 label="name"
                                 :loading="loading_campaigns"
                                 @select="selectModel"
                                 @remove="deselectModel">
                    </multiselect>
                    <p class="invalid-feedback" v-if="form.errors.has('campaign_id')">
                        {{ form.errors.get('campaign_id') }}
                    </p>
                </div>

                <div class="form-group">
                    <label class="mb-0">
                        <input type="checkbox" @click="sendLater = !sendLater"/>
                        Send later
                    </label>
                </div>

                <div class="form-group" v-if="sendLater">
                    <label>Select a date and time</label>
                    <div class="input-group">
                        <flat-pickr class="form-control"
                                    v-model="form.send_at"
                                    :config="config"
                                    placeholder="Select date"
                                    name="date">
                        </flat-pickr>
                        <div class="input-group-append">
                            <button class="btn btn-default" type="button" title="Clear" data-clear=""
                                    @click="form.send_at = null">
                                <i class="fa fa-times"></i>
                            </button>
                        </div>
                    </div>
                    <p class="invalid-feedback" v-if="form.errors.has('send_at')">
                        {{ form.errors.get('send_at') }}
                    </p>
                </div>

                <div class="form-row">
                    <div class="col text-right">
                        <button-loading class="btn btn-primary px-4" type="button"
                                        :loading="form.submitting"
                                        data-dismiss="modal"
                                        @click="sendNow">
                            {{ !sendLater ? 'Send' : 'Schedule'}}
                        </button-loading>
                    </div>
                </div>
            </div>
        </modal>

        <modal ref="openConfirmGroupInviteModal" size="lg">
            <div class="d-block text-center" slot="title">Confirm Group Invite</div>

            <div class="alert alert-warning mb-0">
                This invite will be send to <strong>{{ total_contacts }} contacts</strong>.
                Are you sure you want to continue?
            </div>

            <span slot="footer">
                <button type="button" class="btn btn-default" @click="closeModal()">Cancel</button>
                <button type="button" class="btn btn-primary" @click="sendInviteGroup()">Yes</button>
            </span>
        </modal>
    </div>
</template>

<script>
    import flatPickr      from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';
    import {mapState}     from 'vuex';
    import ModalComponent from '../../mixins/ModalComponent';

    export default {
        mixins: [ModalComponent],
        props : {
            groups   : {
                type    : Array,
                default : [],
                required: true,
            },
            locations: {
                type    : Array,
                default : [],
                required: true,
            },
        },

        data() {
            return {
                key              : null,
                location_id      : null,
                campaigns        : [],
                campaign_id      : null,
                form             : new Form(),
                sendLater        : false,
                loading_campaigns: false,
                config           : {
                    wrap      : true, // set wrap to true only when using 'input-group'
                    altFormat : 'M j, Y H:i',
                    altInput  : true,
                    enableTime: true,
                    dateFormat: "Y-m-d H:i",
                    minDate   : "today",
                },
                contacts         : [],
                total_contacts   : 0
            };
        },

        components: {
            flatPickr
        },

        created() {
            this.setupForm();
        },

        computed: {
            ...mapState({
                filter: state => state.filter,
            }),

            modalSize() {
                return this.showErrorsTable ? 'lg' : 'md';
            }
        },

        watch: {
            sendLater() {
                if (!this.sendLater) {
                    this.form.send_at = null;
                }
            }
        },

        methods: {
            afterOpen() {
                this.setupForm();
                this.showErrorsTable  = false;
                this.location_id      = null;
                this.campaign_id      = null;
                this.key              = Math.random().toString(36);
                this.bulkInviteErrors = [];
                this.sendLater        = false;
                this.contacts         = [];
            },

            setupForm() {
                this.form = new Form({
                    location_id: null,
                    campaign_id: null,
                    groups     : this.groups,
                    is_group   : true,
                });
            },

            fetchCampaigns(location_id) {
                this.loading_campaigns = true;
                this.form.campaign_id  = null;
                this.campaigns         = [];
                return this.$http.get(this.$laroute.route('api.locations.campaigns', {location: location_id}))
                           .then(({data}) => {
                               this.campaigns         = data.data;
                               this.loading_campaigns = false;
                           });
            },

            locationSelected(location) {
                this.form.location_id = location.id;
                this.fetchCampaigns(location.id);
            },

            selectModel(model, option) {
                this.form[option] = model.id;
            },

            deselectModel(model, option) {
                this.form[option] = undefined;
            },

            async sendNow() {
                this.form.scheduled = this.sendLater;
                this.form.contacts  = this.contacts;

                if (!this.contacts.length) {
                    this.form.post(this.$laroute.route('api.invites.store-group'))
                        .then(response => {
                            if (response.data.total > 0) {
                                this.contacts       = response.data.contacts;
                                this.total_contacts = response.data.total;
                                this.confirmSendInviteToGroup();
                                return;
                            }
                        })
                        .catch(({data}) => {
                            swal.fire({
                                title: data.title,
                                text : data.message,
                                type : 'error',
                            })
                        });

                    return;
                }

                this.form.post(this.$laroute.route('api.invites.store-group'))
                    .then(response => {
                        this.$alert({
                            type : 'success',
                            title: 'Invite sent!'
                        });

                        this.$emit('unselectAll');
                    })
                    .catch(({data}) => {
                        swal.fire({
                            title: data.title,
                            text : data.message,
                            type : 'error',
                        })
                    });
            },

            sendInviteGroup() {
                this.$refs.openConfirmGroupInviteModal.close();
                this.sendNow();
            },

            confirmSendInviteToGroup() {
                this.$refs.modal.close();
                this.$refs.openConfirmGroupInviteModal.open();
            },

            closeModal() {
                this.contacts       = [];
                this.total_contacts = 0;
                this.$refs.openConfirmGroupInviteModal.close();
                this.$refs.modal.open();
            },
        }
    }
</script>
